import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../../theme';

export const useNewQuoteFormStyles = createStyles(
  ({ token }, { doubleLine } = {}) => ({
    root: {
      '.DateTimePicker.expand-size .Col-DatePicker': {
        width: '50%',
        flex: '2 1',

        [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
          {
            marginLeft: 0,
            marginRight: ThemeSpaces.SPACE_NORM,
          },
      },

      '.JobLocationCardBody': {
        [`@media (max-width: ${token.screenMDMax}px)`]: {
          paddingTop: ThemeSpaces.SPACE_NORM0_5,
        },
      },

      '.NewShipmentPackage-PreviewBody': {
        paddingBottom: ThemeSpaces.SPACE_NORM_20,
        paddingTop: ThemeSpaces.SPACE_NORM,

        [`@media (min-width: ${token.screenMD}px)`]: {
          paddingLeft: ThemeSpaces.SPACE_NORM_20,
        },

        [`.${doubleLine}`]: {
          marginTop: ThemeSpaces.SPACE_NORM,
          marginBottom: ThemeSpaces.SPACE_NORM,
        },
      },
      '.AddOrCopyPackageButtons': {
        marginTop: 10,
      },
    },
    newShipmentServiceInformationCard: {
      paddingTop: ThemeSpaces.SPACE_NORM,

      [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
        {
          paddingLeft: ThemeSpaces.SPACE_NORM_20,
          paddingRight: ThemeSpaces.SPACE_NORM,
        },
    },
    jobLocationCardSectionHeader: {
      [`@media (max-width: ${token.screenMDMax}px)`]: {
        marginBottom: ThemeSpaces.SPACE_NORM0_5,
      },
    },
    jobLocationCardSection: {
      [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
        {
          paddingLeft: '0 !important',
        },
    },
    newQuoteCol: {
      [`@media (max-width: ${token.screenLGMax}px)`]: {
        '&:first-child': {
          paddingRight: `${ThemeSpaces.SPACE_NORM0_5}px !important`,
          paddingLeft: `${ThemeSpaces.SPACE_NORM}px !important`,
        },
        '&:last-child': {
          paddingRight: `${ThemeSpaces.SPACE_NORM}px !important`,
          paddingLeft: `${ThemeSpaces.SPACE_NORM0_5}px !important`,
        },
      },
      [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
        {
          '&:first-child': {
            paddingRight: '0 !important',
            paddingLeft: '0 !important',
          },
          '&:last-child': {
            paddingLeft: `${ThemeSpaces.SPACE_NORM}px !important`,
            paddingRight: '0 !important',
          },
        },
    },
    newQuotePackagesCardBody: {
      [`@media (max-width: ${token.screenLGMax}px)`]: {
        marginBottom: ThemeSpaces.SPACE_NORM_20,
      },

      '&& .DimensionalWeightResultLabel': {
        fontFamily: ThemeFont.FONT_CONDENSED,
        fontWeight: 700,
        fontSize: token.fontSizeLG,

        [`@media (max-width: ${token.screenSMMax}px)`]: {
          fontSize: token.fontSize,
        },
      },

      '.NewShipmentPackagesSummary-Badge': {
        width: 85,
        height: 30,
      },
      [`@media (min-width: ${token.screenSMMin}px)`]: {
        '.NewShipmentPackagesSummary-Badge': {
          width: 100,
        },
      },
      [`@media (min-width: ${token.screenMDMin}px)`]: {
        '.NewShipmentPackagesSummary-Badge': {
          width: 130,
        },
      },

      '&& .DimensionalWeightResult, .DimensionalWeightResultSeparator, && .NewShipmentPackage-BilledWeight':
        {
          fontSize: token.fontSizeLG,
          lineHeight: 'inherit',

          [`@media (max-width: ${token.screenSMMax}px)`]: {
            fontSize: token.fontSize,
          },
        },
      '&& .DimensionalWeightResult:not(.no-value), .DimensionalWeightResultSeparator, && .NewShipmentPackage-BilledWeight':
        {
          fontWeight: 700,
        },
      '.DimensionalWeightResult, .NewShipmentPackage-BilledWeightValue': {
        color: token.colorPrimary,
      },

      '.DimensionalWeightResultSeparator': {
        paddingLeft: token.paddingXXS,
        paddingRight: token.paddingXXS,
      },

      '.DimensionalWeightResultSeparator, .NewShipmentPackage-BilledWeight': {
        color: ThemeColors.COLOR_GREY_BLUISH,
      },

      '.ant-row .text': {
        fontSize: token.fontSize,
      },

      '.NewShipmentPackage-Title': {
        marginBottom: ThemeSpaces.SPACE_MD,
        height: 'auto',
        lineHeight: 1.5715,
      },

      '.AddOrCopyPackageButtons': {
        position: 'absolute',
        marginTop: ThemeSpaces.SPACE_NORM,
      },
    },
    newQuoteDGCard: {
      marginBottom: ThemeSpaces.SPACE_NORM_20,
    },
  })
);
